import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

import { POST_SELECTED_WHEN } from "../../store/action";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import SelectProfilUser from "../elements/select_profil_user";

const LayoutUserProfile = () => {

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  let userData = useSelector((state) => state.user);

  const [profil, setProfil] = useState({
    firstname: userData?.firstname,
    lastname: userData?.lastname,
    email: userData?.email,
    number: userData?.number
  });

  const [address, setAddress] = useState({
    phone_number: "",
    street_address: "",
    line_address: "",
    receiver_name: "",
    instruction: "",
    lat: null,
    lng: null
  });

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    if (selectedWhen === null || selectedWhen < tday) {
      WhenDate(tday);
    }

  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <SelectProfilUser
          lang={selectedLang}
          user={userData}
          profil={profil}
          setProfil={setProfil}
          address={address}
          setAddress={setAddress}
          setLanguage={() => {}}
        />
      </div>
    </div>
  );
};

export default LayoutUserProfile;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});
